export enum PackageName {
  standard = 'standard',
  enterprise = 'enterprise',
}
